<!-- Map Container -->
<div class="contact-map margin-bottom-55">
  <!-- Google Maps -->
  <div class="google-map-container">
    <!-- <div id="propertyMap" data-latitude="40.7427837" data-longitude="-73.11445617675781"></div> -->
    <iframe src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d110056.16750303727!2d67.0907263!3d24.9223606!3m2!1i1024!2i768!4f13.1!2m1!1spakmatti%20com!5e1!3m2!1sen!2s!4v1739100313602!5m2!1sen!2s" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  </div>
  <!-- Google Maps / End -->
  <!-- Office -->
  <div class="address-box-container">
    <div class="address-container" style="background-image: url('/assets/images/our-office.jpg')">
      <div class="office-address">
        <h3>Our Office</h3>
        <ul>
          <li>We are new startup from Karachi</li>
          <li>will update our address as soon as possible!</li>

        </ul>
      </div>
    </div>
  </div>
  <!-- Office / End -->
</div>
<div class="clearfix"></div>
<!-- Map Container / End -->
<!-- Container / Start -->
<div class="container">
  <div class="row">
    <!-- Contact Details -->
    <div class="col-md-4">
      <h4 class="headline margin-bottom-30">Find Us There</h4>
      <!-- Contact Details -->
      <div class="sidebar-textbox">
        <ul class="contact-details">
          <li><i class="im im-icon-Phone-2"></i> <strong>Phone:</strong> <a
              href="tel:03178611123"><span>031-786-111-23</span></a></li>
          <li><i class="im im-icon-Globe"></i> <strong>Web:</strong> <span><a [routerLink]="'/'">www.pakmatti.com</a></span>
          </li>
          <li><i class="im im-icon-Envelope"></i> <strong>[routerLink]-Mail:</strong> <span><a href="mailto:admin@pakmatti.com"><span
                  class="__cf_email__">admin&#64;pakmatti.com</span></a></span></li>
        </ul>
      </div>
    </div>
    <!-- Contact Form -->
    <div class="col-md-8">
      <section id="contact">
        <h4 class="headline margin-bottom-35">Contact Form</h4>
        <form (ngSubmit)="saveContact(contactForm)" class="submit-section" #contactForm="ngForm">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" [class.has-error]="fullNameControl.invalid && fullNameControl.touched"
                [class.has-success]="fullNameControl.valid">
                <label for="fullName" class="control-label">Full Name:<i class="fa fa-asterisk"></i></label>
                <input type="text"  maxlength="35" name="fullName" class="form-control input-text" [(ngModel)]="FullName" required
                  #fullNameControl="ngModel" />
                <div class="notification error" *ngIf="fullNameControl.invalid && fullNameControl.touched">
                  <p>Full name is required</p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" [class.has-error]="emailAddressControl.invalid && emailAddressControl.touched"
                [class.has-success]="emailAddressControl.valid">
                <label for="emailAddress" class="control-label">Email Address:<i class="fa fa-asterisk"></i></label>
                <input name="emailAddress"  maxlength="35" type="email" [(ngModel)]="EmailAddress" class="input-text"
                  required #emailAddressControl="ngModel" />
                <div class="notification error"
                  *ngIf="(emailAddressControl.value == undefined || emailAddressControl.value == '') && emailAddressControl.touched">
                  <p> Email address field is required</p>
                </div>
                <div class="notification error"
                  *ngIf="emailAddressControl.value != undefined && emailAddressControl.value.length >= 1 && emailAddressControl.invalid && emailAddressControl.touched">
                  <p> Email address is not valid</p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group" [class.has-error]="phoneNumberControl.invalid && phoneNumberControl.touched"
            [class.has-success]="phoneNumberControl.valid">
            <label for="phoneNumber" class="control-label">Phone Number:<i class="fa fa-asterisk"></i></label>
            <input name="phoneNumber" type="text"  maxlength="16" (keypress)="numberOnly($event)" onpaste="return false;" ondrag="return false;" ondrop="return false;" [(ngModel)]="PhoneNumber" class="input-text" required
              #phoneNumberControl="ngModel" />
            <div class="notification error" *ngIf="phoneNumberControl.invalid && phoneNumberControl.touched">
              <p> Phone number field is required</p>
            </div>
          </div>
          <div class="form-group" [class.has-error]="subjectControl.invalid && subjectControl.touched"
            [class.has-success]="subjectControl.valid">
            <label for="subject" class="control-label">Subject:<i class="fa fa-asterisk"></i></label>
            <input name="subject" type="text" maxlength="35" id="subject" [(ngModel)]="Subject" #subjectControl="ngModel"
              class="input-text" required />
            <div class="notification error" *ngIf="subjectControl.invalid && subjectControl.touched">
              <p>Subject field is required</p>
            </div>
          </div>
          <div class="form-group" [class.has-error]="messageControl.invalid && messageControl.touched"
            [class.has-success]="messageControl.valid">
            <label for="message" class="control-label">Message:<i class="fa fa-asterisk"></i></label>
            <textarea name="message" rows="3" [(ngModel)]="Message" #messageControl="ngModel"
              class="input-text" spellcheck="true" required></textarea>
            <div class="notification error" *ngIf="messageControl.invalid && messageControl.touched">
              <p>Message field is required</p>
            </div>
          </div>
          <input type="submit" class="submit button" id="submit" value="Submit Message"
            [disabled]="contactForm.invalid" />
        </form>
      </section>
    </div>
  </div>
</div>
